import { render, staticRenderFns } from "./UseModal.vue?vue&type=template&id=f4ae6f4e"
import script from "./UseModal.vue?vue&type=script&lang=js"
export * from "./UseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports